import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SliderDataItem } from '../../models/slider.model';

@Component({
  selector: 'app-custom-slider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-slider.component.html',
  styleUrl: './custom-slider.component.scss',
})
export class CustomSliderComponent implements OnInit, OnDestroy {
  @Input() showButtons: boolean = false;
  @Input() timerMs: number = 3000;
  @Input() sliderData: SliderDataItem[] = [];

  currentIndex = 1;
  intervalId: any;

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    // clear interval to prevent memory leaks
    this.startAutoSlide();
  }

  prevSlide(): void {
    this.currentIndex =
      this.currentIndex > 0
        ? this.currentIndex - 1
        : this.sliderData.length - 1;
  }

  nextSlide(): void {
    this.currentIndex =
      this.currentIndex < this.sliderData.length - 1
        ? this.currentIndex + 1
        : 0;
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  startAutoSlide(): void {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, this.timerMs);
  }

  stopAutoSlide(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
